import "./style.css";
import InstallerFileDownload from "components/InstallerFileDownload";
// import { useLocation } from "react-router-dom";
// import { useMemo } from "react";

const Download = () => {
  //   const location = useLocation();
  //   const hasInstructionParam = useMemo(
  //     () => new URLSearchParams(location.search).has("instruction"),
  //     [location.search]
  //   );

  return (
    <>
      <a href="https://productivemachines.co.uk/">
        <img
          className="login-logo m-2 ml-4"
          src="assets/images/ll4.png"
          alt="Productive Machines Logo"
        />
      </a>
      <div className="account-pages m-0 download-page-container">
        <div className="download-page-content">
          <div className="download-page-inner">
            <div className="row border-class">
              <div className="col d-flex align-items-center justify-content-center">
                <div className="d-flex align-items-center justify-content-center flex-column">
                  <div className="p-1">
                    <h1 className="download-page-title">SenseNC Feeds</h1>
                    <h1 className="download-page-title mt-4">
                      Try if for FREE
                    </h1>
                    <div className="download-page-description">
                      <h5 className="download-page-subtitle mt-4">
                        Get optimal feed rates autonomously for complex
                        toolpaths within your NX CAM environment.
                      </h5>
                      <h5 className="download-page-subtitle mt-4">
                        Easy-to-use, ultra-fast Siemens NX CAM plug-in optimizes
                        5-axis toolpaths with feed rates based on equalization
                        of forces and chip thickness.
                      </h5>
                    </div>
                  </div>
                  <InstallerFileDownload
                    buttonText={
                      //   hasInstructionParam
                      //     ? "Download instructions for SenseNC" :
                      "Download Installer for SenseNC"
                    }
                    fileName={
                      //   hasInstructionParam ? "instruction.pdf" :
                      "sensenc.zip"
                    }
                    className="download-page-button"
                  />
                </div>
              </div>
              <div className="col d-flex align-items-center justify-content-center">
                <img
                  className="login-image mr-5"
                  src="assets/images/ProductionMachinesLaptop.png"
                  alt="SenseNC on laptop demonstration"
                  width="600"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Download;
